import { render, staticRenderFns } from "./deviceBenchmark.vue?vue&type=template&id=5454403b&scoped=true&"
import script from "./deviceBenchmark.vue?vue&type=script&lang=js&"
export * from "./deviceBenchmark.vue?vue&type=script&lang=js&"
import style0 from "./deviceBenchmark.vue?vue&type=style&index=0&id=5454403b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5454403b",
  null
  
)

export default component.exports